import React from 'preact/compat';
import {h} from 'preact';
import {useEffect, useState} from 'preact/hooks';
import posService from "../service/posService";
import Spinner from './Spinner';
import constants from "../constants";
import ToastIcon from "./icon/ToastIcon";
import locationService from "../service/locationService";
import ConfigIcon from "./icon/ConfigIcon";
import { BarsOutlined, SettingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const source = constants.IMPORT_SOURCE_TOAST;

export function ToastPosMenuImport(props) {
  const [importing, setImporting] = useState(false);
  const [toastAccountMissing, setToastAccountMissing] = useState(false);
  const [email, setEmail] = useState(props.toastEmail);
  const [assignMode, setAssignMode] = useState(false);
  const [activePosLocation, setActivePostLocation] = useState(null);
  const [activeMhmLocation, setActiveMhmLocation] = useState(null);
  const [posLocations, setPosLocations] = useState([]);
  const [mhmLocations, setMhmLocations] = useState(window.data.locations);
  const [selPosLocation, setSelPosLocation] = useState(null);

  useEffect(() => {
    const found = window.data.locations.find(it => it.internalId === window.data.design.locationId);
    setActiveMhmLocation(found);
    fetchPosLocations(found).then();
  }, []);

  async function fetchPosLocations(foundMhmLocation) {
    const mhmLocation = foundMhmLocation ?? activeMhmLocation;
    let fetching = false;

    setImporting(true);
    try {
      const toastLocations = (await posService.getToastRestaurants(email)).data.sort((a, b) => b.createdDate - a.createdDate);

      toastLocations.forEach(toast => {
        const foundMhmLocation = mhmLocations.find(mhm => mhm.toastLocationId === toast.restaurantGuid);
        if (foundMhmLocation) {
          toast.mhmLocationId = foundMhmLocation.internalId;
          toast.mhmLocation = foundMhmLocation.name;
          foundMhmLocation.posLocation = toast.locationName || toast.restaurantName;
          foundMhmLocation.posLocationId = toast.restaurantGuid;
        }
      })

      setMhmLocations([...mhmLocations]);
      setPosLocations(toastLocations);
      if (toastLocations.length === 1) {
        setActivePostLocation(toastLocations[0]);
        fetchMenus(toastLocations[0]);
        fetching = true;
      } else if (!!mhmLocation && !!mhmLocation.toastLocationId) {
        const found = toastLocations.find(it => it.restaurantGuid === mhmLocation.toastLocationId);
        if (found) {
          setActivePostLocation(found);
          fetchMenus(found);
          fetching = true;
        }
      }

      setToastAccountMissing(false);
    } catch (e) {
      setToastAccountMissing(true);
    }
    if (!fetching) {
      setImporting(false);
    }
  }

  function fetchMenus(posLocation) {
    if (!posLocation || !posLocation.restaurantGuid) return;
    setImporting(true);

    try {
      posService.getToastMenus(posLocation.restaurantGuid).then(resp => {
        if (resp.data && resp.data.length) {
          let menus = resp.data;
          const mapped = menus
            .filter(it => it.sections.filter(it => !it.removed).length > 0 && !it.removed)
            .map(menu => posService.mapMenu(menu, source, posLocation.restaurantName));
          props.onSuccess(mapped, "Toast");
        }
        setImporting(false);
      })
    } catch (e) {
      setImporting(false);
    }
  }

  function doneAssign() {
    const data = [];
    posLocations.forEach(it => {
      if (it.mhmLocationId) {
        data.push({
          id: it.mhmLocationId,
          posLocationId: it.restaurantGuid
        });

        if (it.mhmLocationId === activeMhmLocation.internalId) {
          setActivePostLocation(it);
          fetchMenus(it);
        }
      }
    });

    locationService.assignToastLocation(data);
    window.data.locations = mhmLocations;

    setAssignMode(false);
  }

  function onToastLocationClick(location) {
    if (!!location.mhmLocationId) return;
    posLocations.forEach(it => it.selected = false);
    location.selected = !location.selected;
    setSelPosLocation(location);
    setPosLocations([...posLocations]);
  }

  function onMhmLocationClick(mhmLocation) {
    if (!selPosLocation || !!mhmLocation.posLocationId) return;
    if (selPosLocation) {
      mhmLocations.forEach(it => {
        if (it.posLocationId === selPosLocation.restaurantGuid) {
          it.posLocation = "";
          it.posLocationId = "";
        }
        it.mhmLocationId = "";
        it.mhmLocation = "";
      });

      mhmLocation.posLocation = selPosLocation.locationName || selPosLocation.restaurantName;
      mhmLocation.posLocationId = selPosLocation.restaurantGuid;

      selPosLocation.mhmLocationId = mhmLocation.internalId;
      selPosLocation.mhmLocation = mhmLocation.name;
      selPosLocation.selected = false;
    }

    posLocations.forEach(it => it.selected = false);
    setSelPosLocation(null);
    setMhmLocations([...mhmLocations]);
    setPosLocations([...posLocations]);
  }

  function clearLink(mhmLocation) {
    mhmLocation.posLocation = "";
    mhmLocation.posLocationId = "";
    const found = posLocations.find(it => it.mhmLocationId === mhmLocation.internalId);
    if (!!found) {
      found.mhmLocationId = "";
      found.mhmLocation = "";
    }

    setMhmLocations([...mhmLocations]);
    setPosLocations([...posLocations]);
  }

  return <div className={"pos-menu"}>
    {importing && <div><Spinner/></div>}

    {!importing && <section>
      {toastAccountMissing &&
        <div>
          <span>No restaurants found. Please enter your e-mail address used in Toast.</span>
          <input type={'text'} value={email} onChange={e => setEmail(e.target.value)}/>
          <button className={'btn primary'} onClick={fetchPosLocations}>Search</button>
        </div>
      }

      {!assignMode && <header className={"pos-loc-assign"}>
        <div>
          <span className={"toast"}>
            <ToastIcon/>
          </span>
          {!!activePosLocation && <h6>
            {activePosLocation.locationName || activePosLocation.restaurantName}
          </h6>}
          {!activePosLocation && 
          <h6 className="link" onClick={() => setAssignMode(true)}>
            + Assign Location
          </h6>}
        </div>
        <div className={"sep"}>/</div>
        <div>
          <span className={"mhm"}>mhm</span>
          <h6>{window.data.design.locationName}</h6>
        </div>

        <div className={"cfg"}>
          <Tooltip placement='bottom' title='Assign Locations'>
            <a onClick={() => setAssignMode(true)}><SettingOutlined /></a>
          </Tooltip>
        </div>
      </header>}

      {!activePosLocation && !assignMode &&
      <div class="no-data-message" style="height: 400px;">
        <BarsOutlined/>
        <h3>No data available</h3>
        <p>Assign a POS location to this MustHaveMenus location</p>  
        <button className={"btn primary large"} onClick={() => setAssignMode(true)}>
          Assign Locations
        </button>
      </div>}

      {assignMode && <div className={"assign-locs"}>
        <h3>Assign your POS locations to your MustHaveMenus locations</h3>
        <p>First select a POS location, then select a MustHaveMenus location to assign it to</p>

        <div className="lists">
          <ul className={"ls-toast"}>
            <li className={'pos-list-header'}>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/Toast.svg" alt="Toast logo"/>
              <h3>Toast</h3>
            </li>
            {posLocations.map(it =>
              <li key={it.restaurantGuid} className={`${!!it.mhmLocation ? "disabled" : ""}`}>
                <div onClick={() => onToastLocationClick(it)} className={`loc ${it.selected ? "sel" : ""}`}>
                  <span>{it.locationName || it.restaurantName}</span>
                  {it.mhmLocation && <span className={"s"}>{it.mhmLocation}</span>}
                </div>
              </li>)}
          </ul>
          <ul className={"ls-mhm"}>
            <li className={'pos-list-header'}>
              <img src="https://timber.mhmcdn.com/site/marketing/icons/MHMCircle.svg" alt="mhm logo"/>
              <h3>MustHaveMenus</h3>
            </li>
            <li className={"new-loc"}>
              <a href="/home/account/locations" target="_blank">+ Add Locations</a>
            </li>
            {mhmLocations.map(it =>
              <li key={it.id} className={`${(!selPosLocation || !!it.posLocationId) ? "disabled" : ""}`}>
                <div onClick={() => onMhmLocationClick(it)} className={`loc`}>
                  <span>{it.name}</span>
                  {it.posLocation && <span className={"s"}>{it.posLocation}</span>}
                </div>

                {it.posLocation && <button className={"clear"} onClick={() => clearLink(it)}>Clear</button>}
              </li>)}
          </ul>
        </div>

        <footer>
          <a className="btn primary medium" onClick={doneAssign}>
            Done
          </a>
        </footer>
      </div>}
    </section>}
  </div>
}
